(function () {
    angular.module('tmx-app').controller('scanFingerPrintController', ['$scope', '$mdDialog', 'TMX_FINANCE_CONSTANTS', 'ToastService', 'cacheStore', 'tmxUtility',
        function scanFingerPrintController($scope, $mdDialog, TMX_FINANCE_CONSTANTS, ToastService, cacheStore, tmxUtility) {

            var supportedDevices = TMX_FINANCE_CONSTANTS.SUPPORTED_DEVICES_FINGERPRINT;
            var configuredDevice = tmxUtility.getConfigurationValue(cacheStore.get("Configurations"), "FINGER_PRINT_DEVICE");
            // configuredDevice = "FGTIT"; // For testing
            var FgitSocket = null;
            var ISO = null;
            var ws = null;
            $scope.showReconnectDevice = false;
            //Initialize with empty image


            (function InitializeDialog() {
                ResetVariables();
                InitializeFingerPrintDevice();
            })();

            function InitializeFingerPrintDevice() {
                if (configuredDevice == supportedDevices.FGTIT) {
                    $scope.showReconnectDevice = false;
                    FgitSocket = ConnectFGITWebSocket();
                }
            }
            function ResetVariables() {
                $scope.imgData = null;
                ISO = null;
            }


            function GetTemplate() {
                try {
                    if (FgitSocket != null && FgitSocket.readyState == 1) {
                        //ws.send("capture");
                        var cmd = "{\"cmd\":\"capture\",\"data1\":\"\",\"data2\":\"\"}";
                        FgitSocket.send(cmd);
                    }
                    else {
                        $scope.showReconnectDevice = true;
                        ToastService.showCustomToast("error", "Either server is not up or device is disconnected, please reconnect and try again")
                    }
                }
                catch (err) {
                    console.log("error: ", err);
                }
            }

            function ConnectFGITWebSocket() {
                var host = TMX_FINANCE_CONSTANTS.CONFIGS.FGTIT_WS_URL;
                var ws = null;
                if ("WebSocket" in window) {
                    ws = connect(host);
                }
                else {
                    console.log("browser does not support sockets");
                }

                return ws;
            }

            function connect(host) {
                try {
                    ws = new WebSocket(host); // create the web socket
                }
                catch (err) {
                    console.error(err);
                    return;
                }
                ws.onmessage = function (evt) {
                    var obj = eval("(" + evt.data + ")");
                    var status = { value: "" };
                    switch (obj.workmsg) {
                    case 1:
                        status.value = "Please Open Device";
                        ToastService.showCustomToast("error", status.value);
                        break;
                    case 2:
                        status.value = "Place Finger";
                        ToastService.showCustomToast("success", status.value);
                        break;
                    case 3:
                        status.value = "Lift Finger";
                        ToastService.showCustomToast("success", status.value);
                        break;
                    case 4:
                        break;
                    case 5:
                        if (obj.retmsg == 1) {
                                // eslint-disable-next-line no-empty
                            if (obj.data2 == "null") {
                                console.log("Error in capturing data, Captured Object :", obj);
                            }
                            else {
                                ISO = obj.data2;
                            }
                        }
                        else {
                            console.error("Get Template Fail");
                        }
                        break;
                    case 6:
                        break;
                    case 7:
                            //eslint-disable-next-line no-empty
                        if (obj.image == "null") {
                        }
                        else {
                            var img = "data:image/png;base64," + obj.image;
                            ISO = obj.image;
                            $scope.imgData = img;

                        }
                        break;
                    case 8:
                        status.value = "Time Out";
                        ToastService.showCustomToast("error", status.value);
                        break;
                    case 9:
                        status.value = "Match Result:" + obj.retmsg;
                        break;
                    }

                };
                ws.onerror = function () {
                    if ($scope.showReconnectDevice == true) {
                        ToastService.showCustomToast("error", "Server is not Up");
                    }
                    return ws;
                }
                ws.onopen = function () {
                    if ($scope.showReconnectDevice == true) {
                        $scope.showReconnectDevice = false;
                        ToastService.showCustomToast("error", "Server is Connected Now Please Try again");
                    }
                    return ws;
                }
                return ws;
            }

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.reconnectDevice = function () {
                FgitSocket = ConnectFGITWebSocket();
                if (FgitSocket != null && FgitSocket.readyState == 1) {
                    ToastService.showCustomToast("success", "Device/Server Connected");
                }
            }
            $scope.captureFingerPrint = function () {
                ResetVariables();
                if (configuredDevice == supportedDevices.FGTIT) {
                    GetTemplate();
                }
                else {
                    // eslint-disable-next-line no-undef
                    tx_deviceGet(supportedDevices.SECUGEN, function (response) {
                        response = JSON.parse(response);
                        if (response.STATUS == "SUCCESS") {
                            ISO = response.FP_ISO;
                            $scope.imgData = "data:image/png;base64," + response.FP_IMG;
                        }
                        else {
                            ISO = null;
                            $scope.imgData = null;
                        }
                    });
                }
            }
            $scope.done = function () {
                $mdDialog.hide($scope.imgData);
            }

            $scope.$on('$destroy', function () {
                try{
                    if (tmxUtility.exists(ws)) {
                        ws.onclose = function () {};
                        ws.close();
                        ws = null;
                    }
                }
                catch(exception){
                    console.log(exception);
                }
            });

        }]);
})();